import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import { getSalidasTablero, } from '../../../helpers/backend_helper';
import {DestroyAlertHelper,Alert,ToastHelper,ToastContainerHelper} from '../../../helpers/alerts/alertHelper';
import {Container, Row} from "reactstrap";
import { useParams } from 'react-router-dom';

const SalidasTablero = () => {

    let timeElapsed = new Date();
    let dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth()+1 < 10 ? '0':''}${timeElapsed.getMonth()+1}-${timeElapsed.getDate()} ${timeElapsed.getHours()}:${timeElapsed.getMinutes()}:${timeElapsed.getSeconds()}`;
    const {url_route} = useParams();
    console.log(timeElapsed.getMinutes())
    const [pending, setPending] = useState(false);
    const [dataPag, setDataPag] = useState({total:0});
    const [filters,setFilters] = useState({
        page:1,
        perPage:20,
        orderBy:'id',
        order:'asc',
        initDate:dateNow,
        url_route:url_route
    });
    const [items, setItems] = useState([]);
    
    const dispatch = useDispatch()
    useEffect(() => {
        const getSalidas = async () =>{
            const response = await getSalidasTablero(url_route,params)
            if(!response.status){
                setItems(response.data)
                setDataPag(response.meta)
                setPending(false)    
            }
            setPending(false)
        }

        let params={params:filters}
        
        setPending(true)
        getSalidas()
    }, [filters])


    const columns = Columns(items,setItems);  document.title = "Salidas";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <ToastContainerHelper />
                        <DataTableHelper tittle="Salidas" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters} filterInp={false}>
                            
                        </DataTableHelper>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default SalidasTablero ;